const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getPrograms(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/programs`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch programs');
  }
  
  const data = await response.json();
  return data.programs;
}

export async function getProgram(orgId, programId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/programs/${programId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Program not found');
    }
    throw new Error('Failed to fetch program');
  }
  
  return response.json();
}

export async function getEnrollments(orgId, programId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.status) params.append('status', filters.status);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/programs/${programId}/enrollments${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch enrollments');
  }
  
  const data = await response.json();
  return data.enrollments;
}

export async function createEnrollment(orgId, programId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/programs/${programId}/enrollments`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create enrollments');
    }
    throw new Error('Failed to create enrollment');
  }
  
  const result = await response.json();
  return result.enrollment;
}

export async function updateEnrollment(orgId, enrollmentId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/enrollments/${enrollmentId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to update enrollments');
    }
    if (response.status === 404) {
      throw new Error('Enrollment not found');
    }
    throw new Error('Failed to update enrollment');
  }
  
  const result = await response.json();
  return result.enrollment;
}

export async function createProgram(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/programs`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create programs');
    }
    throw new Error('Failed to create program');
  }
  
  const result = await response.json();
  return result.program;
}
